export default __webpack_public_path__ + "static/media/m-first-ex-1.47cd2530.png";